<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Manajemen Referral</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Manajemen Referral</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9">
							 <div class="card">
								<div class="card-body pt-0" style="min-height:530px">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#tabprofit" data-toggle="tab">Manajemen Referral</a>                                                
											</li> 

											<li class="nav-item">
												<a class="nav-link" href="#tabpenarikan" data-toggle="tab">Permohonan Penarikan Komisi</a>                                                
											</li> 
                                             
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
										
										<!-- Materi Tab -->
										<div id="tabprofit" class="tab-pane fade show active">
											<div class="card card-table mb-0">

                                                <div class="card-body">

													<div class="table-responsive">
                                                        <table id="tblWallet" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="text-left">User</th>
                                                                    <th class="text-left">Kode Referral</th>
                                                                    <th class="text-left">Total Komisi</th>
                                                                    <th class="text-left">Saldo Komisi</th>
                                                                    <th class="text-left">Komisi Dicairkan</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lstwallet" :key="ref.id_user">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.namauser }}</td>
                                                                    <td>{{ ref.kode_referral }}</td>
                                                                    <td class="text-right">{{ ref.total_profit }}</td>
                                                                    <td class="text-right">{{ ref.sisa_saldo }}</td>
                                                                    <td class="text-right">{{ ref.total_cair }}</td>
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-info-light" depressed small @click="getDetail(ref)">
                                                                            <i class="fas fa-eye"></i> Detail
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
                                                
                                            </div>
                                        </div>

                                        
										<div id="tabpenarikan" class="tab-pane fade">
											<div class="card card-table mb-0">
                                                <div class="card-body">

													<div class="table-responsive">
                                                        <table id="tblPenarikan" class="table table-hover table-center mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left">#</th>
                                                            <th class="text-ceter">User</th>
                                                            <th class="text-ceter">Tanggal Transaksi</th>
                                                            <th class="text-center">Nominal</th>
                                                            <th class="text-center">Keterangan</th>
                                                            <th class="text-center">Jenis Transaksi</th>
                                                            <th class="text-center">Status</th>
                                                            <th class="text-left">Action</th>
                                                        </tr>
                                                    </thead>
                                
                                                    <tbody>
                                                        <tr v-for="(ref, index) in lstpenarikan" :key="ref.id">
                                                            <td>{{ index + 1 }}</td>
                                                            <td>{{ ref.namauser }}</td>
                                                            <td>{{ ref.tgl_transaksi }}</td>
                                                            <td class="text-right">{{ ref.nilai_transaksi_lbl }}</td>
                                                            <td>{{ ref.keterangan }}</td>
                                                            <td class="text-center">
                                                                <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.fg_status == '1' || ref.fg_status == '2'  , 'bg-success-light' : ref.fg_status == '2'}">{{ref.status_nm}}</span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.fg_approval == '0' , 'bg-success-light' : ref.fg_approval == '1', 'bg-danger-light' : ref.fg_approval == '-2' }">{{ref.approval_nm}}</span>
                                                            </td>
                                                            
                                                            <td>
                                                                <v-btn class="btn btn-sm bg-danger-light" depressed small data-toggle="modal" data-target="#penarikanMdl" @click.prevent="resetPenarikan(ref)">
                                                                Detail
                                                                </v-btn>
                                                            </td>
                                                        
                                                        </tr>
                                                    </tbody>                                            
                                                </table>
                                                     
                                                    </div>
												</div>
                                            </div>
                                        </div>

                                    </div>
                                    
                                </div>
                            </div>
							
                           
							

						</div>
					</div>
				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>

    
        <div id="detailMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document" style="width:90% !important">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Detail Komisi</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        
							<div class="row">
								<div class="col-md-12">
									<div class="card dash-card">
										<div class="card-body">
											<div class="row">
												<div class="col-md-12 col-lg-4">
													<div class="dash-widget dct-border-rht">
														<div class="circle-bar circle-bar2">
														    <img src="https://img.icons8.com/external-icongeek26-outline-gradient-icongeek26/64/000000/external-gift-essentials-icongeek26-outline-gradient-icongeek26.png"/>
                                                        </div>
														<div class="dash-widget-info">
															<h6>Total Komisi</h6>
															<h3>{{wallet.total_profit}}</h3>
															<!-- <p class="text-muted">2021 2022</p> -->
														</div>
													</div>
												</div>
												
												<div class="col-md-12 col-lg-4">
													<div class="dash-widget dct-border-rht">
														<div class="circle-bar circle-bar3">
															<img src="https://img.icons8.com/external-icongeek26-outline-gradient-icongeek26/64/000000/external-wallet-essentials-icongeek26-outline-gradient-icongeek26.png"/>
														</div>
														<div class="dash-widget-info">
															<h6>Sisa Komisi belum dicairkan</h6>
															<h3>{{wallet.sisa_saldo}}</h3>
															<!-- <p class="text-muted">2021 2022</p> -->
														</div>
													</div>
												</div>
												
												<div class="col-md-12 col-lg-4">
													<div class="dash-widget">
														<div class="circle-bar circle-bar3">
															<img src="https://img.icons8.com/external-icongeek26-outline-gradient-icongeek26/64/000000/external-bank-essentials-icongeek26-outline-gradient-icongeek26.png"/>
                                                            </div>
														<div class="dash-widget-info">
															<h6>Total Komisi Dicairkan</h6>
															<h3>{{wallet.total_cair}}</h3>
															<!-- <p class="text-muted">2021 - 2022</p> -->
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							
							<div class="row">
								<div class="col-md-12">

									<div class="card">
                                        <div class="card-body">
                                            <div class="sender-widget">
                                                <div class="doc-info-left">
                                                    <div class="doc-info-cont">
                                                        <h6 class="doc-name">Referral User {{wallet.namauser}}</h6>
                                                        <!-- <div class="shop-details">
                                                            <p class="doc-location">segera share kode referralmu, dan dapatkan banyak profit yang menguntungkan :)</p>
                                                        </div>  -->
                                                        <p class="doc-department"><img src="@/assets/img/specialities/specialities-05.png" class="img-fluid" alt="Speciality">Kode Refferal user: <b>{{wallet.kode_referral}}</b></p>
                                                        
                                                    </div>
                                                </div>
                                                <div class="doc-info-right">
                                                    <div class="clini-infos">
                                                        <ul>
                                                            <!-- <li><button class="btn btn-sm btn-secondary mb-0.5"  @click.prevent="getMateri(item)">Copy Refferal</button></li> -->
                                                            <li><button class="btn btn-sm bg-primary-light mb-0.5"   v-clipboard:copy="link_referral" v-clipboard:success="onCopy" >Copy Link Refferal</button></li>
       
                                                            <!-- <li><button class="btn btn-sm bg-warning-light mb-0.5" data-toggle="modal" data-target="#penarikanMdl" @click.prevent="resetPenarikan(null)">Ajukan penarikan</button></li> -->
                                                           
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card card-table mb-0">
                                        <div class="card-body">
                                            <div class="table-responsive">
                                                <table id="tblTransaksi" class="table table-hover table-center mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left">#</th>
                                                            <th class="text-ceter">Tanggal Transaksi</th>
                                                            <th class="text-center">Nominal</th>
                                                            <th class="text-center">Keterangan</th>
                                                            <th class="text-center">Jenis Transaksi</th>
                                                            <th class="text-center">Status</th>
                                                            <!-- <th class="text-left">Action</th> -->
                                                        </tr>
                                                    </thead>
                                
                                                    <tbody>
                                                        <tr v-for="(ref, index) in lsttransaksi" :key="ref.id">
                                                            <td>{{ index + 1 }}</td>
                                                            <td>{{ ref.tgl_transaksi }}</td>
                                                            <td class="text-right">{{ ref.nilai_transaksi_lbl }}</td>
                                                            <td>{{ ref.keterangan }}</td>
                                                            <td class="text-center">
                                                                <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.fg_status == '1' , 'bg-success-light' : ref.fg_status == '2'}">{{ref.status_nm}}</span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.fg_approval == '0' , 'bg-success-light' : ref.fg_approval == '1', 'bg-danger-light' : ref.fg_approval == '-2' }">{{ref.approval_nm}}</span>
                                                            </td>
                                                            
                                                            <!-- <td>
                                                                <template v-if="ref.fg_approval == '0' && ref.fg_status != '1'">
                                                                    <v-btn class="btn btn-sm bg-danger-light" depressed small data-toggle="modal" data-target="#penarikanMdl" @click.prevent="resetPenarikan(ref)">
                                                                    Edit
                                                                    </v-btn>
                                                                </template>
                                                            </td> -->
                                                        
                                                        </tr>
                                                    </tbody>                                            
                                                </table>
                                            
                                            </div>
                                        </div>
                                    </div>
                            
								</div>
							</div>

                    </div>
                </div>
            </div>
        </div>

        <div id="penarikanMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Form Penarikan</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form id="frm">                            
                            <div class="row">
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Nama User</label>
                                        <input class="form-control" type="text" v-model="walletdtl.namauser" disabled="disabled">
                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Saldo Tersedia</label>
                                        <input class="form-control" type="text" v-model="walletdtl.sisa_saldo" disabled="disabled">
                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Nominal Penarikan</label>
                                        <!-- <input class="form-control" type="text" v-model="walletdtl.nilai_transaksi"> -->
                                        <number class="form-control" v-model="walletdtl.nilai_transaksi" @input="updateNet" v-bind="number" required></number>

                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Biaya Transfer</label>
                                        <!-- <input class="form-control" type="text" v-model="walletdtl.nilai_transaksi"> -->
                                        <number class="form-control" v-model="walletdtl.fee_transfer" v-bind="number" readonly></number>

                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Net Transfer</label>
                                        <!-- <input class="form-control" type="text" v-model="walletdtl.nilai_transaksi"> -->
                                        <number class="form-control" v-model="walletdtl.net_transfer" v-bind="number" readonly></number>

                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Nama Bank</label>
                                        <input class="form-control" type="text" v-model="walletdtl.pnama_bank"  disabled="disabled">
                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>No Rekening</label>
                                        <input class="form-control" type="text" v-model="walletdtl.pno_rekening"  disabled="disabled">
                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Nama Pemilik Rekening</label>
                                        <input class="form-control" type="text" v-model="walletdtl.patas_nama"  disabled="disabled">
                                    </div>
                                </div>

                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Status Approval</label>
                                        <v-select
                                        :options="lststs"
                                        :reduce="lststs => lststs.id" 
                                        label="text"
                                        v-model="walletdtl.fg_approval"
                                        />
                                        
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div class="submit-section text-center">
                            <button class="btn btn-primary submit-btn" @click.prevent="savePenarikan">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
		<!-- /Main Wrapper -->
</template>

<script>
import Sidebar from '../Sidebar';
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'
import Number  from 'vue-number-format'

export default {
    components: {
        Sidebar, Number
    },
	name: 'ProfileSetting',
	data() {
		return {
            lstwallet: [],
            kode_referral: '',
			number: {
				decimal: '.',
				separator: ',',
				prefix: 'I ',
				// suffix: ' #',
				precision: 0,
				masked: false
			},
			wallet: {
                total_profit:'',
                sisa_saldo:'',
                total_cair:''
            },
            walletdtl: {
                id:'',
                nilai_transaksi: 0,
                pno_rekening: '',
                patas_nama: '',
                pnama_bank: '',
                fee_transfer: 5550,
                net_transfer: 0
            },
            lsttransaksi:[],    
            lstpenarikan: [],        
            lststs: [
                {id: '0', text: 'PENDING'},
                {id: '1', text: 'APPROVED'}
            ],
            link_referral:''
		}
	},
	
    created: function () {
        this.getAll();
        // this.kode_referral = localStorage.getItem("kodeRef");
    },
	methods: {
        
        updateNet: function () {
                if(parseInt(this.walletdtl.nilai_transaksi) > 0){
                    this.walletdtl.net_transfer = parseInt(this.walletdtl.nilai_transaksi) - parseInt(this.walletdtl.fee_transfer);            
                }
        },

        onCopy: function (e) {
            // alert('You just copied the following text to the clipboard: ' + e.text)
            let timerInterval
            swal.fire({
            title: 'Kode Referral',
            html: 'kode referral '+e.text+' berhasil dicopy!',
            timer: 1000,
            // icon: 'success',
            timerProgressBar: true,
            didOpen: () => {
                swal.showLoading()
                const b = swal.getHtmlContainer().querySelector('b')
                timerInterval = setInterval(() => {
                b.textContent = swal.getTimerLeft()
                }, 100)
            },
            willClose: () => {
                clearInterval(timerInterval)
            }
            }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === swal.DismissReason.timer) {
                console.log('I was closed by the timer')
            }
            })
            
        },
        
        updateValue(event) {
        // const value = event.target.value
        // console.log(value, this.amount)
        console.log(this.walletdtl.nilai_transaksi);
        if (parseInt(this.walletdtl.nilai_transaksi) > parseInt(this.wallet.sisa_saldo) || parseInt(this.walletdtl.nilai_transaksi) < 0) {
            // this.amount = value
            this.walletdtl.nilai_transaksi = 0;
            // this.$forceUpdate()
        }
        },

		initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,

                });
               }, 300)
        },
        
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },

        resetPenarikan(ref){
            if(ref != null){
                this.walletdtl =  ref;
            } else {
                this.walletdtl =  {
                    nilai_transaksi: 0,
                    pno_rekening: '',
                    patas_nama: '',
                    pnama_bank: '',
                    fee_transfer: 5550,
                    net_transfer:0
                };
            }
        },

        //--------------------------
        // Get Wallet
        getAll: function () {
            axios.get('api/wallet')
                .then(res => {
                    this.clearTbl("tblWallet");
                    this.lstwallet = res.data.data.lstwallet;  
                    this.initDt("tblWallet");
                    
                    this.clearTbl("tblPenarikan");
                    this.lstpenarikan = res.data.data.lstpenarikan;  
                    this.initDt("tblPenarikan");
                    // if(this.wallet.list_transaksi.length){ 
                    //     this.clearTbl("tblTransaksi");
                    //     this.lsttransaksi = this.wallet.list_transaksi;
                    //     this.initDt("tblTransaksi");
                    // }
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        
        savePenarikan: function () {
            // console.log("cek isi");
            // console.log(parseInt(this.walletdtl.nilai_transaksi));
            // console.log(parseInt(this.wallet.saldo));
            if (parseInt(this.walletdtl.nilai_transaksi) > parseInt(this.walletdtl.saldo) || parseInt(this.walletdtl.nilai_transaksi) < 0) {
                
                 let timerInterval
                    swal.fire({
                    title: 'Peringatan',
                    html: '<div class="success-cont">'+
                                '<i class="fas fa-times"></i>'+
                                '<h3>Nilai Transaksi tidak boleh lebih dari Sisa saldo!</h3>'+
                                // '<p>Nilai yang anda dapatkan adalah <strong> '+this.tryout.hasil+'</strong></p>'+
                                // '<router-link to="/admin/tryout" class="btn btn-primary view-inv-btn">Selesai</router-link>'+
                            '</div>',
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: () => {
                        swal.showLoading()
                        const b = swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
                        
                    })
            } else{

                axios.post('api/updwalletpenarikan', {
                        walletdtl: this.walletdtl
                    })
                    .then(res => {
                        // handle success
                        this.getAll();
                        this.resetPenarikan(null);
                        $("#penarikanMdl").modal('hide');
                    })
                    .catch(err => {
                        // handle error
                        console.log(err);
                    })
            }
        },

        getDetail: function (ref) {
            $("#detailMdl").modal('show');
            
            axios.get('api/walletuser/'+ref.id_user)
            .then(res => {
                this.wallet = res.data.data;  
                this.link_referral = window.location.origin+"/referral?koderef="+this.wallet.kode_referral;

                this.clearTbl("tblTransaksi");
                if(this.wallet.list_transaksi.length){ 
                    this.lsttransaksi = this.wallet.list_transaksi;
                    this.initDt("tblTransaksi");
                }
            })
            .catch(err => {
                // handle error
                console.log(err);
            })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/Admin/Wallet/index.vue